// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';

import TitledCard from 'common/components/cards/TitledCard';
import { RowWrapper, Label } from '../styles';
import type { RadioInformationFormSection, GeneralInformationsData } from '../../domain/RadioInformationForm';

type Props = {
  onChange: (value: RadioInformationFormSection) => void,
  data: GeneralInformationsData,
  t: any,
}

function GeneralInformations(props: Props) {
  const radioTypeObject = 'radioType';

  const onRadioTypeChange = (key: string, value: boolean) => {
    props.onChange({
      ...props.data,
      radioType: {
        ...props.data.radioType,
        [key]: value,
      },
    });
  };

  return (
    <TitledCard title={props.t('generalInformations')}>
      <div className="row">
        <div className="col-xs-8">
          <Label>{props.t('stationName')}</Label>
          <TextField
            name="stationName"
            onChange={(e, v) => props.onChange({ ...props.data, stationName: v })}
            value={props.data.stationName}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('frequency')}</Label>
          <TextField
            name="frequency"
            onChange={(e, v) => props.onChange({ ...props.data, frequency: v })}
            value={props.data.frequency}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('radioType')}</Label>
        </div>
      </div>
      <RowWrapper className="row">
        <div className="col-xs-3">
          <Checkbox
            label={props.t('commercial')}
            name="commercial"
            onCheck={(e, v) => onRadioTypeChange('commercial', v)}
            checked={props.data[radioTypeObject].commercial}
          />
        </div>
        <div className="col-xs-3">
          <Checkbox
            label={props.t('musical')}
            name="musical"
            onCheck={(e, v) => onRadioTypeChange('musical', v)}
            checked={props.data[radioTypeObject].musical}
          />
        </div>
        <div className="col-xs-3">
          <Checkbox
            label={props.t('talk')}
            name="talk"
            onCheck={(e, v) => onRadioTypeChange('talk', v)}
            checked={props.data[radioTypeObject].talk}
          />
        </div>
      </RowWrapper>
      <RowWrapper className="row">
        <div className="col-xs-3">
          <Checkbox
            label={props.t('community')}
            name="community"
            onCheck={(e, v) => onRadioTypeChange('community', v)}
            checked={props.data[radioTypeObject].community}
          />
        </div>
        <div className="col-xs-3">
          <Checkbox
            label={props.t('ethnic')}
            name="ethnic"
            onCheck={(e, v) => onRadioTypeChange('ethnic', v)}
            checked={props.data[radioTypeObject].ethnic}
          />
        </div>
      </RowWrapper>
      <RowWrapper className="row">
        <div className="col-xs-8">
          <Label>{props.t('address')}</Label>
          <TextField
            name="address"
            onChange={(e, v) => props.onChange({ ...props.data, address: v })}
            value={props.data.address}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('city')}</Label>
          <TextField
            name="city"
            onChange={(e, v) => props.onChange({ ...props.data, city: v })}
            value={props.data.city}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('zipCode')}</Label>
          <TextField
            name="zipCode"
            onChange={(e, v) => props.onChange({ ...props.data, zipCode: v })}
            value={props.data.zipCode}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('website')}</Label>
          <TextField
            name="website"
            onChange={(e, v) => props.onChange({ ...props.data, website: v })}
            value={props.data.website}
            fullWidth
          />
        </div>
      </RowWrapper>
    </TitledCard>
  );
}

export default translate('radioConfiguration')(GeneralInformations);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/radioInformationForm/GeneralInformations.js